import React from "react";
import YoutubeEmbed from "./YoutubeEmbed";

const VideosAdigrat = () => {
  return (
    <div className="main-content">
      <div className="gallery_group">
        <div className="gallery_item">
          <YoutubeEmbed
            embedId="x5FGmo6XmkY"
            inputWidth="360"
            inputHeight="300"
          />
        </div>
        <div className="gallery_item">
          <YoutubeEmbed
            embedId="Od3FYBpBjek"
            inputWidth="360"
            inputHeight="300"
            caption="Rediet for Tegaru Women, Training, Adwa, 2025 (2018 ግአዝ)
            ትካል ረዲኤት ንተጋሩ ደቂኣንስትዮ ኣብ ዝተፈላለየ ወረዳታት ትግራይ ሓጋዚ ንዘይብለን ሓለፍቲ ስድራ ኣደታት እግሪ ንኽተትክል 
            ምስ ማሕበር ደቂኣንስትዮ ትግራይ ብምትሕብባር ዝተገበረ ናይ ስንልቦና ሕውየት፣ ናይ ንግዲን ንስራሕ ምልዕዓልን ኣብ ዓድዋ 
            ዝተካየደ ስልጠና። 
            2025 (2018 ግአዝ)፣ ዓድዋ"
          />
        </div>
        <div className="gallery_item">{/* when available add one here */}</div>
        <div className="gallery_item">{/* when available add one here */}</div>
      </div>
    </div>
  );
};

export default VideosAdigrat;
